import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetOtherUsesByNamesInputDto, GetOtherUsesInputDto, OtherUseCreateDto, OtherUseDto, OtherUseExcelDownloadDto, OtherUseUpdateDto } from '../dtos/other-use/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class OtherUseService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: OtherUseCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtherUseDto>({
      method: 'POST',
      url: '/api/planning/otherUses',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/otherUses/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/otherUses',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  findByNames = (input: GetOtherUsesByNamesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtherUseDto[]>({
      method: 'POST',
      url: '/api/planning/otherUses/by-names',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtherUseDto>({
      method: 'GET',
      url: `/api/planning/otherUses/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/otherUses/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetOtherUsesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<OtherUseDto>>({
      method: 'GET',
      url: '/api/planning/otherUses',
      params: { name: input.name, otherUsearea: input.otherUsearea, otherUseareaFrom: input.otherUseareaFrom, otherUseareaTo: input.otherUseareaTo, soilUseId: input.soilUseId, soilUseName: input.soilUseName, locationId: input.locationId, locationName: input.locationName, propertyTypeId: input.propertyTypeId, propertyTypeName: input.propertyTypeName, propertyId: input.propertyId, propertyName: input.propertyName, isFOManagement: input.isFOManagement, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: OtherUseExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/otherUses/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, otherUsearea: input.otherUsearea, otherUseareaFrom: input.otherUseareaFrom, otherUseareaTo: input.otherUseareaTo, soilUseId: input.soilUseId, soilUseName: input.soilUseName, locationId: input.locationId, locationName: input.locationName, propertyTypeId: input.propertyTypeId, propertyTypeName: input.propertyTypeName, propertyId: input.propertyId, propertyName: input.propertyName, isFOManagement: input.isFOManagement, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtherUseDto[]>({
      method: 'GET',
      url: '/api/planning/otherUses/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  recalculateGisAreas = (otherUseIds: number[], cancellationToken?: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/planning/otherUses/recalculate-gis-areas',
      body: otherUseIds,
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: OtherUseUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtherUseDto>({
      method: 'PUT',
      url: `/api/planning/otherUses/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}